import * as React from "react"
import Layout from "../components/Layout"
import { StaticImage } from "gatsby-plugin-image"
import Contact from "../components/Contact/Contact"
import Seo from "../components/SEO"
import SimpleBanner from "../components/SimpleBanner/SimpleBanner"

const contacto = () => {
  return (
    <>
      <Seo title="Contacto" />
      <Layout>
        <SimpleBanner title="Ponte en contacto con nuestra galería">
          <StaticImage
            className="banner__image"
            src="../../static/marcos-molduras-enmarcados-profesional.jpg"
            alt="Apple Macbook Dark"
          />
        </SimpleBanner>
        <Contact />
      </Layout>
    </>
  )
}

export default contacto
